import React from 'react';
import { HandlingUnit } from '../types/handling_unit/handlingUnit';

export interface HandlingUnitContextProps {
  handlingUnits: Map<string, HandlingUnit>;
  setHandlingUnits: (handlingUnits: Map<string, HandlingUnit>) => void;
  handlingUnitsLoading: boolean;
  breakPedigrees: Map<string, HandlingUnit[]>;
  bundlePedigrees: Map<string, HandlingUnit[]>;
  // TODO: Remove

  handlingUnitConnections: Map<string, Set<string>>;
}

const defaultContext: HandlingUnitContextProps = {
  handlingUnits: new Map(),
  setHandlingUnits: () => {},
  handlingUnitsLoading: false,
  handlingUnitConnections: new Map(),

  breakPedigrees: new Map(),
  bundlePedigrees: new Map(),
};

export const HandlingUnitContext = React.createContext<HandlingUnitContextProps>(defaultContext);
